import React from 'react';
import { Box, Paper, Typography, alpha } from '@mui/material';
import { motion } from 'framer-motion';
import CountUp from './CountUp';
import { fadeInUp, hoverLift } from '../utils/motion';

const MotionPaper = motion(Paper);

// Color-coded by meaning (mint = positive, coral = negative, amber = pending,
// indigo = neutral/brand) rather than as decoration -- see Dashboard/Attendance
// for how each stat picks its color.
const StatCard = ({ icon, label, value, suffix = '', color, dense = false }) => (
  <MotionPaper
    variants={fadeInUp}
    {...hoverLift}
    elevation={0}
    sx={{
      p: dense ? 2 : 2.75,
      borderRadius: '18px',
      display: 'flex',
      alignItems: 'center',
      gap: 1.75,
      position: 'relative',
      overflow: 'hidden',
      border: '1px solid',
      borderColor: (t) => alpha(t.palette.text.primary, t.palette.mode === 'dark' ? 0.08 : 0.06),
      background: (t) =>
        t.palette.mode === 'dark' ? alpha(t.palette.background.paper, 0.6) : t.palette.background.paper,
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 4,
        backgroundColor: color,
      }}
    />
    <Box
      sx={{
        width: dense ? 40 : 48,
        height: dense ? 40 : 48,
        flexShrink: 0,
        borderRadius: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color,
        backgroundColor: alpha(color, 0.14),
      }}
    >
      {icon}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant={dense ? 'h6' : 'h5'} sx={{ fontFamily: 'var(--font-display)', fontWeight: 700, lineHeight: 1.2 }}>
        <CountUp value={value} suffix={suffix} />
      </Typography>
      <Typography variant="body2" color="text.secondary" noWrap>{label}</Typography>
    </Box>
  </MotionPaper>
);

export default StatCard;
